import '../../CssFiles/MemberPrefill.css';
import { CreditLimitInput } from '../Credit/CreditLimit';
import React, { 
    useState, 
    useEffect 
} from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import ProfilePictureUpload from '../../Components/ProfilePictureUpload/ProfilePictureUpload'
import toast from 'react-hot-toast';
import dayjs from 'dayjs';
import imageCompression from 'browser-image-compression';
import { ClassOptions } from '../../Utils/api/DropdownfilterApi';
import { nationalities } from '../../Utils/Common';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Form,
    Input,
    Divider,
    Space,
    DatePicker,
    Checkbox,
    Select,
    Alert,
    Modal,
    Radio,
    Steps,
} from 'antd'
import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'

const { TextArea } = Input;
const { Item } = Form;
const { Option } = Select;

const AddEditMember = () => {
    // const [members, setMembers] = useState([]);
    // const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate()
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [corporateData, setCorporateData] = useState([]);
    const [memberId, setMemberId] = useState(' ');
    const [addForm] = Form.useForm();

    const selectedClass = Form.useWatch('class', addForm);
    const canEnterCreditLimit = ['Assignee Members A', 'Assignee Members B', 'Assignee Members C'].includes(selectedClass);

    useEffect(() => {
        if (selectedClass && !canEnterCreditLimit) {
            addForm.setFieldValue('credit_limit', null);
        }
    }, [selectedClass, canEnterCreditLimit, addForm]);

    const memberClassFormats = {
        'Class A': { prefix: 'P', suffix: 'A' },
        'Class B': { prefix: 'P', suffix: 'B' },
        'Class C': { prefix: 'P', suffix: 'C' },
        'Assignee Members A': { prefix: 'A', suffix: 'A' },
        'Assignee Members B': { prefix: 'A', suffix: 'B' },
        'Assignee Members C': { prefix: 'A', suffix: 'C' },
    };

    const memberClassFormat = memberClassFormats[selectedClass];

    const handleClassChange = (value) => {
        const format = memberClassFormats[value];
        const currentMemberNo = addForm.getFieldValue('member_no') || '';

        // Identify a Member ID previously formatted by the selected class.
        const match = currentMemberNo.match(/^[PA]-(\d{0,4})-[ABC]$/);

        const digits = match
            ? match[1]
            : /^\d{0,4}$/.test(currentMemberNo)
            ? currentMemberNo
            : '';

        if (format) {
            // Apply automation only to Class A/B/C and Assignee Members A/B/C.
            addForm.setFieldsValue({
            member_no: `${format.prefix}-${digits}-${format.suffix}`,
            });
        } else if (match) {
            // Remove the automatic prefix and suffix for other classes.
            addForm.setFieldsValue({
            member_no: match[1],
            });
        }
    };
    const { 
        id,
        type 
    } = useParams();
    const { callPost, loading, data } = usePostRequest(()=>{

    });
    useEffect(() => {
        if(data && data.response){
            navigate('/member/profile/', { state: { id: data?.response?.member_id } })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    const [identityForm] = Form.useForm();
    const [prefillStep, setPrefillStep] = useState('identity');
    const [checkedIdentity, setCheckedIdentity] = useState(null);
    const [selectedSource, setSelectedSource] = useState(null);
    const [lookupError, setLookupError] = useState('');
    const [prefillMatches, setPrefillMatches] = useState([]);
    const [prefillSource, setPrefillSource] = useState(null);
    const [prefillLoading, setPrefillLoading] = useState(false);

    const applyPrefill = (member) => {
        const { source_member_id, latest_status, first_name, last_name, ...personal } = member;
        const dates = ['birthdate', 'date_issued', 'expiry_date', 'other_expiry_date', 'date'];
        dates.forEach(field => {
            personal[field] = personal[field] && dayjs(personal[field]).isValid()
                ? dayjs(personal[field]) : null;
        });
        personal.is_st_lucia = String(personal.is_st_lucia) === '1';
        // Keep the freshly generated AR ID and never reuse account identifiers.
        personal.corporate_id = undefined;
        personal.credit_limit = null;
        const format = memberClassFormats[member.class];
        personal.member_no = format ? `${format.prefix}--${format.suffix}` : '';
        addForm.setFieldsValue(personal);
        setAge(personal.birthdate ? dayjs().diff(personal.birthdate, 'years') : null);
        setPrefillSource(member);
    };

    const checkIdentity = async (values) => {
        setPrefillLoading(true);
        setLookupError('');
        try {
            const identity = {
                first_name: values.first_name.trim(),
                last_name: values.last_name.trim(),
                birthdate: values.birthdate.format('YYYY-MM-DD'),
            };
            const result = await UseGetRequest('members/prefill_matches', identity);
            if (!Array.isArray(result?.data?.members)) throw new Error('Lookup failed');
            setCheckedIdentity(identity);
            setPrefillMatches(result.data.members);
            setSelectedSource(result.data.members.length === 1 ? result.data.members[0].source_member_id : null);
            setPrefillStep('result');
        } catch {
            setLookupError('Unable to check existing members. Please try again.');
        } finally {
            setPrefillLoading(false);
        }
    };

    const openMemberForm = () => {
        const arId = addForm.getFieldValue('ar_cust_id');
        addForm.resetFields();
        setPrefillSource(null);
        setAttachmentsData([]);
        addForm.setFieldsValue({ ...checkedIdentity, birthdate: dayjs(checkedIdentity.birthdate), ar_cust_id: arId });
        setAge(dayjs().diff(dayjs(checkedIdentity.birthdate), 'years'));
        if (prefillMatches.length) {
            const source = prefillMatches.find(member => member.source_member_id === selectedSource);
            if (!source || isActiveMatch(source) || !source.latest_status?.trim()) return;
            applyPrefill(source);
        }
        setPrefillStep('details');
    };

    const isActiveMatch = member => member.latest_status?.trim().toLowerCase() === 'active';
    const hasActiveMatch = prefillMatches.some(isActiveMatch);
    const hasUnknownStatus = prefillMatches.some(member => !member.latest_status?.trim());

    const handleImageUpload = async (file) => {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 300,
          useWebWorker: true,
        };
      
        try {
          const compressedFile = await imageCompression(file, options);
          return compressedFile;
        } catch (error) {
          toast.error('Invalid File: ',error)
        }
    };

    const handleSaveImage = async(data) => {
        const compressedFile = await handleImageUpload(data.file);
        setAttachmentsData(compressedFile)
    };

    async function fetchMembersData() {
        const response = await UseGetRequest("members/get_all", {member_id: id});
        if (response?.data) {
            const edit_data = response?.data?.members[0]
            setMemberId(edit_data.id)
            setAttachmentsData(edit_data.profile_pic_url)
            setAge(edit_data.age)
            addForm.setFieldsValue({
                member_no: edit_data?.member_no,
                last_name: edit_data.last_name,
                first_name: edit_data.first_name,
                middle_name: edit_data.middle_name,
                suffix: edit_data.suffix,
                type: edit_data.type,
                class: edit_data.class,
                tin: edit_data.tin,
                place_issued: edit_data.place_issued,
                res_cert_no: edit_data.res_cert_no,
                sellers_code: edit_data.sellers_code,
                corporate_id: edit_data.corporate_id,
                date_issued: edit_data.date_issued ? dayjs(edit_data.date_issued) : undefined,
                expiry_date: edit_data.expiry_date ? dayjs(edit_data.expiry_date) : undefined,
                assignor: edit_data.assignor,
                credit_limit: edit_data.credit_limit ?? null,
                remarks: edit_data.remarks,
                title: edit_data.title,
                is_st_lucia: edit_data?.is_st_lucia === "1" ? true : false,
                gender: edit_data.gender,
                civil_status: edit_data.civil_status,
                nationality: edit_data.nationality,
                birthdate: edit_data.birthdate ? dayjs(edit_data.birthdate) : undefined,
                place_of_birth: edit_data.place_of_birth,
                voting_member: edit_data.voting_member,
                ar_cust_id: edit_data.ar_cust_id,
                certificate_no: edit_data.certificate_no,
                insurance: edit_data.insurance,
                other_expiry_date: edit_data.other_expiry_date ? dayjs(edit_data.other_expiry_date) : undefined,
                approved_by: edit_data.approved_by,
                date: edit_data.date ? dayjs(edit_data.date) : undefined,
                category: edit_data.category,
                nickname: edit_data.nickname,
                age: edit_data.age,
                sc_pwd_id: edit_data.sc_pwd_id,
            });
        } else {
            addForm.resetFields();
        }    
    }

    async function fetchCorporateData() {
        const response = await UseGetRequest("corporates/get_member_corporate");
        if (response?.data) {
          setCorporateData(response?.data?.member_corporates);
        } else {
          setCorporateData([])
        }
    }

    const handleAddMember = () => {
        addForm.validateFields().then(values => {
            const newValues = {
                member_no: values.member_no || ' ',
                last_name: values.last_name || ' ',
                first_name: values.first_name || ' ',
                middle_name: values.middle_name || ' ',
                suffix: values.suffix || ' ',
                type: values.type || ' ',
                class: values.class || ' ',
                tin: values.tin || ' ',
                place_issued: values.place_issued || ' ',
                res_cert_no: values.res_cert_no || ' ',
                sellers_code: values.sellers_code || ' ',
                corporate_id: values.corporate_id || ' ',
                date_issued: values.date_issued?.format("YYYY-MM-DD") || ' ',
                expiry_date: values.expiry_date?.format("YYYY-MM-DD") || ' ',
                assignor: values.assignor || ' ',
                remarks: values.remarks || ' ',
                title: values.title || ' ',
                is_st_lucia: values?.is_st_lucia ? '1' : '0',
                gender: values.gender || ' ',
                civil_status: values.civil_status || ' ',
                nationality: values.nationality || ' ',
                birthdate: values.birthdate?.format("YYYY-MM-DD") || ' ',
                place_of_birth: values.place_of_birth || ' ',
                voting_member: values.voting_member || ' ',
                ar_cust_id: values.ar_cust_id || ' ',
                certificate_no: values.certificate_no || ' ',
                insurance: values.insurance || ' ',
                other_expiry_date: values.other_expiry_date?.format("YYYY-MM-DD") || ' ',
                approved_by: values.approved_by || ' ',
                date: values.date?.format("YYYY-MM-DD") || ' ',
                category: values.category || ' ',
                age: age || ' ',
                nickname: values.nickname || ' ',
                sc_pwd_id: values.sc_pwd_id || ' ',
            }

            if (canEnterCreditLimit && values.credit_limit !== undefined &&
                values.credit_limit !== null && values.credit_limit !== '') {
                newValues.credit_limit = values.credit_limit;
            }

            if (prefillSource) {
                if (values.birthdate?.format('YYYY-MM-DD') !== prefillSource.birthdate) {
                    toast.error('Birthdate does not match the selected member. Start without copying or select the correct record.');
                    return;
                }
                newValues.prefill_source_id = prefillSource.source_member_id;
            }

            let finalValues = Object.entries({...newValues, profile_pic: attachmentsData || ' '})?.map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "members/add", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
            toast.error('Validation Failed ', errorInfo);
        });
    };

    const handleEditMember = () => {
        addForm.validateFields().then(values => {
            const newValues = {
                member_id: memberId,
                member_no: values.member_no || ' ',
                last_name: values.last_name || ' ',
                first_name: values.first_name || ' ',
                middle_name: values.middle_name || ' ',
                suffix: values.suffix || ' ',
                type: values.type || ' ',
                class: values.class || ' ',
                tin: values.tin || ' ',
                place_issued: values.place_issued || ' ',
                res_cert_no: values.res_cert_no || ' ',
                sellers_code: values.sellers_code || ' ',
                corporate_id: values.corporate_id || ' ',
                date_issued: values.date_issued?.format("YYYY-MM-DD") || ' ',
                expiry_date: values.expiry_date?.format("YYYY-MM-DD") || ' ',
                assignor: values.assignor || ' ',
                remarks: values.remarks || ' ',
                title: values.title || ' ',
                is_st_lucia: values?.is_st_lucia ? values?.is_st_lucia : ' ',
                gender: values.gender || ' ',
                civil_status: values.civil_status || ' ',
                nationality: values.nationality || ' ',
                birthdate: values.birthdate?.format("YYYY-MM-DD") || ' ',
                place_of_birth: values.place_of_birth || ' ',
                voting_member: values.voting_member || ' ',
                certificate_no: values.certificate_no || ' ',
                insurance: values.insurance || ' ',
                other_expiry_date: values.other_expiry_date?.format("YYYY-MM-DD") || ' ',
                approved_by: values.approved_by || ' ',
                date: values.date?.format("YYYY-MM-DD") || ' ',
                category: values.category || ' ',
                nickname: values.nickname || ' ',
                age: age || ' ',
                sc_pwd_id: values.sc_pwd_id || ' ',
            }

            let finalValues = Object.entries({...newValues, profile_pic: attachmentsData?.file || ' '})?.map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "members/update", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
            toast.error('Validation Failed ', errorInfo);
        });
    };

    const [age, setAge] = useState(null);
    const onBirthdateChange = (date) => {
        if (date) {
            const today = dayjs();
            const birthdate = dayjs(date);
            const calculatedAge = today.diff(birthdate, 'years');
            setAge(calculatedAge);
        } else {
            setAge(null);
        }
    };

    useEffect(() => {
        if(type === "edit"){
            fetchMembersData();
        } else {
            UseGetRequest('members/next_ar_customer_id').then(response => {
                if (response?.data?.ar_cust_id) {
                    addForm.setFieldValue('ar_cust_id', response.data.ar_cust_id);
                } else {
                    toast.error('Unable to load the next AR Customer ID. Please reload.');
                }
            }).catch(() => toast.error('Unable to load the next AR Customer ID. Please reload.'));
        }
        fetchCorporateData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);
  
    return (
        <Layout className='page'>
            <Navbar navKey={'member'}/>
            <Layout className='content-container overflow-y p-4'>
                <Row>
                    <Col span={24} className='header-container'>
                        {type === "edit" ? "EDIT" : "ADD"} MEMBER
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        {type === 'add' && prefillStep !== 'details' && (
                            <section className='member-prefill-card'>
                                <Steps size='small' current={0} items={[{ title: 'Identify member' }, { title: 'Complete details' }]} />
                                <h2>Check member details</h2>
                                <p>Enter the member’s name and birthdate to check for an existing membership.</p>
                                <Form form={identityForm} layout='vertical' onFinish={checkIdentity} disabled={prefillLoading}>
                                    <Row gutter={16}>
                                        <Col xs={24} sm={12}><Item label='Last Name' name='last_name' rules={[{ required: true, whitespace: true, message: 'Enter the last name.' }]}><Input autoComplete='off' /></Item></Col>
                                        <Col xs={24} sm={12}><Item label='First Name' name='first_name' rules={[{ required: true, whitespace: true, message: 'Enter the first name.' }]}><Input autoComplete='off' /></Item></Col>
                                        <Col xs={24} sm={12}><Item label='Birthdate' name='birthdate' rules={[{ required: true, message: 'Select the birthdate.' }]}><DatePicker className='w-100' format='YYYY-MM-DD' /></Item></Col>
                                    </Row>
                                    {lookupError && <Alert type='error' showIcon message={lookupError} />}
                                    <div className='member-prefill-actions'>
                                        <Button onClick={() => navigate(-1)}>Cancel</Button>
                                        <Button type='primary' className='button-color' htmlType='submit' loading={prefillLoading}>Check member</Button>
                                    </div>
                                </Form>
                            </section>
                        )}
                        <Modal
                            open={type === 'add' && prefillStep === 'result'}
                            title={hasActiveMatch ? 'Active membership found' : prefillMatches.length ? 'Existing membership found' : 'No existing member found'}
                            onCancel={() => setPrefillStep('identity')}
                            footer={null}
                            className='member-prefill-modal'
                        >
                            {hasActiveMatch ? <Alert type='warning' showIcon message='This member already has an active membership.' description='Go back to review the name and birthdate. A new membership cannot be created for this match.' /> : hasUnknownStatus ? <Alert type='warning' showIcon message='The existing membership has no status.' description='Please have its status verified before creating another membership.' /> : prefillMatches.length ? <>
                                <p>Select the membership to copy personal details from.</p>
                                <Radio.Group className='member-prefill-options' value={selectedSource} onChange={event => setSelectedSource(event.target.value)}>
                                    {prefillMatches.map(member => <Radio key={member.source_member_id} value={member.source_member_id}>
                                        <strong>{[member.first_name, member.middle_name, member.last_name, member.suffix].filter(Boolean).join(' ')}</strong>
                                        <span className='member-prefill-meta'>{member.birthdate} · {member.latest_status} · Record {member.source_member_id}</span>
                                    </Radio>)}
                                </Radio.Group>
                                <p>Personal details, addresses, and dependents will be copied. You’ll review the form before saving a new membership.</p>
                            </> : <p>No existing member found for <strong>{checkedIdentity?.first_name} {checkedIdentity?.last_name}</strong> with birthdate {checkedIdentity?.birthdate}. Continue to complete their details.</p>}
                            <div className='member-prefill-actions'>
                                <Button onClick={() => setPrefillStep('identity')}>Back</Button>
                                {!hasActiveMatch && !hasUnknownStatus && <Button type='primary' className='button-color' disabled={prefillMatches.length > 0 && selectedSource === null} onClick={openMemberForm}>{prefillMatches.length ? 'Copy details' : 'Continue'}</Button>}
                            </div>
                        </Modal>
                        {type === 'add' && prefillStep === 'details' && <div className='member-prefill-summary'>
                            <span>{prefillSource ? 'Personal details copied. Review and complete the new membership.' : 'Complete the new member’s information.'}</span>
                            <Button onClick={() => setPrefillStep('identity')}>Back to member check</Button>
                        </div>}
                        <Form 
                            className={type === 'add' && prefillStep !== 'details' ? 'member-form-hidden' : ''}
                            form={addForm} 
                            layout="vertical"
                        >
                            <Row>
                                <Col xs={24} sm={24} md={8} lg={5} xl={5}>
                                    <ProfilePictureUpload
                                        imageUrl={type === "add" ? null :  attachmentsData}
                                        imageFile={handleSaveImage}
                                    />
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={16} lg={19} xl={19}
                                    className='p-4'
                                >
                                    <Row>
                                        <Col 
                                            xs={24} sm={24} md={8} lg={7} xl={7}
                                            className='p-2'
                                        >
                                            <Item
                                                label="Last Name"
                                                name="last_name"
                                                className='p-0 m-0'
                                                rules={[{ required: true, message: 'Please enter your Last Name!' }]}
                                            >
                                                <Input readOnly={type === 'add'} />
                                            </Item>
                                        </Col>
                                        <Col 
                                            xs={24} sm={24} md={8} lg={7} xl={7}
                                            className='p-2'
                                        >
                                            <Item
                                                label="First Name"
                                                name="first_name"
                                                className='p-0 m-0'
                                                rules={[{ required: true, message: 'Please enter your First Name!' }]}
                                            >
                                                <Input readOnly={type === 'add'} />
                                            </Item>
                                        </Col>
                                        <Col 
                                            xs={24} sm={24} md={8} lg={7} xl={7}
                                            className='p-2'
                                        >
                                            <Item
                                                label="Middle Name"
                                                name="middle_name"
                                                className='p-0 m-0'
                                                // rules={[{ required: true, message: 'Please enter your Middle Name!' }]}
                                            >
                                                <Input/>
                                            </Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col 
                                            xs={24} sm={24} md={10} lg={7} xl={7}
                                            className='p-2'
                                        >
                                            <Item
                                                label="Nickname"
                                                name="nickname"
                                                className='p-0 m-0'
                                            >
                                                <Input/>
                                            </Item>
                                        </Col>
                                        <Col 
                                            xs={12} sm={12} md={6} lg={2} xl={2}
                                            className='p-2'
                                        >
                                            <Item
                                                label="Suffix"
                                                name="suffix"
                                                className='p-0 m-0'
                                                // rules={[{ required: true, message: 'Please enter your Name!' }]}
                                            >
                                                <Input/>
                                            </Item>
                                        </Col>
                                        <Col
                                            xs={24} sm={24} md={8} lg={7} xl={7}
                                            className='p-2'
                                        >
                                            <Item
                                                label="Birthdate"
                                                name="birthdate"
                                                className='p-0 m-0'
                                                extra={`${age || 0} years old`}
                                                rules={[{ required: true, message: 'Please enter your Birthdate!' }]}
                                            >
                                                <DatePicker
                                                    disabled={type === 'add'}
                                                    onChange={onBirthdateChange}
                                                    format="YYYY-MM-DD"
                                                    className='w-100'
                                                />
                                            </Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Divider className='divider-text'>Member Information</Divider>
                            <Row>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Type"
                                        name="type"
                                        className='p-0 m-0'
                                        rules={[{ required: true, message: 'Please enter your Type!' }]}
                                    >
                                        <Select placeholder="Select a name">
                                            <Option value="Alta Vista">Alta Vista</Option>
                                            <Option value="Doble Vista">Doble Vista</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Class"
                                        name="class"
                                        className='p-0 m-0'
                                        rules={[{ required: true, message: 'Please enter your Class!' }]}
                                    >
                                       <Select
                                            onChange={handleClassChange}
                                            options={ClassOptions()}
                                        />
                                    </Item>
                                </Col>
                                                               
                                <Col 
                                    xs={24} sm={24} md={15} lg={6} xl={6}
                                    className='p-2'
                                >
                                <Form.Item
                                    label="Member ID"
                                    name="member_no"
                                    getValueProps={(value) => {
                                        const memberNo = value || '';
                                        const match = memberNo.match(/^[PA]-(\d{0,4})-[ABC]$/);

                                        return {
                                            value: memberClassFormat && match ? match[1] : memberNo,
                                        };
                                }}
                                    getValueFromEvent={(event) => {
                                        const inputValue = event.target.value;

                                        // Other classes retain free input.
                                        if (!memberClassFormat) {
                                            return inputValue;
                                        }

                                        // Accept only four digits.
                                        const digits = inputValue.replace(/\D/g, '').slice(0, 4);

                                        // Store the complete Member ID in the form.
                                        return `${memberClassFormat.prefix}-${digits}-${memberClassFormat.suffix}`;
                                    }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter Member ID.',
                                        },
                                        {
                                        validator: (_, value) => {
                                            if (!memberClassFormat) {
                                                return Promise.resolve();
                                            }

                                            const { prefix, suffix } = memberClassFormat;
                                            const pattern = new RegExp(`^${prefix}-\\d{4}-${suffix}$`);

                                            if (pattern.test(value || '')) {
                                                return Promise.resolve();
                                            }

                                            return Promise.reject(
                                                new Error(
                                                    `Member ID must follow ${prefix}-####-${suffix} with exactly four digits.`
                                            )
                                            );
                                        },
                                    },
                                ]}
                                >
                                <Input
                                    prefix={
                                        memberClassFormat ? `${memberClassFormat.prefix}-` : undefined
                                    }
                                    suffix={
                                        memberClassFormat ? `-${memberClassFormat.suffix}` : undefined
                                    }
                                    maxLength={memberClassFormat ? 4 : undefined}
                                    inputMode={memberClassFormat ? 'numeric' : undefined}
                                    placeholder={memberClassFormat ? '0000' : 'Enter Member ID'}
                                />
                                </Form.Item>
                                </Col>
                                    
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Seller's Code"
                                        name="sellers_code"
                                        className='p-0 m-0'
                                        rules={[{ required: true, message: 'Please enter your Sellers Code' }]}
                                    >
                                        <Select placeholder="Select a name">
                                            <Option value="Sta. Lucia Realty & Dev.,Inc.">Sta. Lucia Realty and Dev., Inc.</Option>
                                            <Option value="Matias Aznar III">Matias Aznar III</Option>
                                            <Option value="Merelo B. Aznar">Merelo B. Aznar</Option>
                                            <Option value="Emmanuel B. Aznar">Emmanuel B. Aznar</Option>
                                            <Option value="Lydia Aznar-Alfonso">Lydia Aznar-Alfonso</Option>
                                            <Option value="Merlo B. Aznar">Merlo B. Aznar</Option>
                                            <Option value="Alma Aznar-Holopainen">Alma Aznar-Holopainen</Option>
                                            <Option value="Christine Aznar">Christine Aznar</Option>
                                            <Option value="Elma Aznar-Sierra">Elma Aznar-Sierra</Option>
                                            <Option value="Virma Ofia Aznar-Velez">Virma Ofia Aznar-Velez</Option>
                                            <Option value="Irma Ritta Aznar">Irma Ritta Aznar</Option>
                                            <Option value="Merelito Aznar Jr.">Merelito Aznar Jr.</Option>
                                            <Option value="George Aznar">George Aznar</Option>
                                            <Option value="Common Aznar Shares">Common Aznar Shares</Option>
                                            <Option value="Golf Force">Golf Force</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="AR Cust ID"
                                        name="ar_cust_id"
                                        className='p-0 m-0'
                                        rules={[{ required: true, message: 'Please wait for the AR Customer ID to load.' }]}
                                    >
                                        <Input disabled placeholder="Automatically assigned"/>
                                    </Item>
                                </Col>
                                 <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Gender"
                                        name="gender"
                                        className='p-0 m-0'
                                        rules={[{ required: true, message: 'Please enter your Gender!' }]}
                                    >
                                        <Select placeholder="Select a name">
                                            <Option value="male">Male</Option>
                                            <Option value="female">Female</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Civil Status"
                                        name="civil_status"
                                        className='p-0 m-0'
                                        rules={[{ required:  true, message: 'Please enter your Civil Status!' }]}
                                    >
                                        <Select placeholder="Select a name">
                                            <Option value="single">Single</Option>
                                            <Option value="married">Married</Option>
                                            <Option value="separated">Separated</Option>
                                            <Option value="widowed">Widowed</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Nationality"
                                        name="nationality"
                                        className='p-0 m-0'
                                        rules={[{ required: true, message: 'Please enter your Nationality!' }]}
                                    >
                                        <Select 
                                            placeholder="Select a Nationality"
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {
                                                nationalities?.map((data) => (
                                                    <Option key={data.name} value={data.name}>{data.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="TIN Number"
                                        name="tin"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Place Issued"
                                        name="place_issued"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Date Issued"
                                        name="date_issued"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <DatePicker style={{width:'100%'}} format="YYYY-MM-DD"/>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Expiry Date"
                                        name="expiry_date"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <DatePicker style={{width:'100%'}} format="YYYY-MM-DD"/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6} className='p-2'>
                                    <Item
                                        label="Corporate ID"
                                        name="corporate_id"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <Select 
                                            placeholder="Select a Corporate ID"
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {
                                                corporateData?.map((data) => (
                                                    <Option key={data.id} value={data.id}>{data.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={6} className='p-2'>
                                    <Item
                                        label="Assignor"
                                        name="assignor"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                {/* <Col xs={24} sm={12} lg={6} className='p-2'>
                                    <Item label="Credit Limit" name="credit_limit" className='p-0 m-0'>
                                        <CreditLimitInput
                                            className='member-credit-limit-input'
                                            placeholder="0.00"
                                            disabled={!canEnterCreditLimit}
                                        />
                                    </Item>
                                </Col> */}
                            </Row>
                            <Row>
                                <Col span={24} className='p-2'>
                                    <Item
                                        label="Remarks"
                                        name="remarks"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <TextArea rows={4}/>
                                    </Item>
                                </Col>
                            </Row>
                            <Divider className='divider-text'>Others</Divider>
                            <Row>
                                <Col span={12} className='p-2'>
                                    <Item
                                        label="Title"
                                        name="title"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Senior Citizen / PWD ID"
                                        name="sc_pwd_id"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="St. Lucia"
                                        name="is_st_lucia"
                                        className='p-0 m-0'
                                        valuePropName="checked"
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <Checkbox>No</Checkbox>
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Place of Birth"
                                        name="place_of_birth"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Voting Member"
                                        name="voting_member"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                   <Item
                                        label="Res Cert No."
                                        name="res_cert_no"
                                        className='p-0 m-0'
                                        rules={[{ required: true, message: 'Please enter your AR Cust ID!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col 
                                    xs={24} sm={24} md={6} lg={6} xl={6}
                                    className='p-2'
                                >
                                    <Item
                                        label="Certificate Number"
                                        name="certificate_no"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12} className='p-2'>
                                    <Item
                                        label="Insurance"
                                        name="insurance"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col span={12} className='p-2'>
                                    <Item
                                        label="Expiry Date"
                                        name="other_expiry_date"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <DatePicker style={{width:'100%'}} format="YYYY-MM-DD"/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12} className='p-2'>
                                    <Item
                                        label="Approved By"
                                        name="approved_by"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col span={12} className='p-2'>
                                    <Item
                                        label="Date"
                                        name="date"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <DatePicker style={{width:'100%'}} format="YYYY-MM-DD"/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12} className='p-2'>
                                    <Item
                                        label="Category"
                                        name="category"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row className='btn-footer'>
                                <Space className='p-2'>
                                    <Button
                                        onClick={() => navigate(-1)}
                                        className='cancel-color btn-header'
                                    >
                                        Cancel
                                    </Button>
                                    {
                                        type === "add" ? (
                                            <Button
                                                onClick={handleAddMember}
                                                disabled={prefillLoading}
                                                loading={loading}
                                                type='primary'
                                                className='button-color btn-header'
                                            >
                                                Submit
                                            </Button>
                                        ) : (
                                            <Button
                                                onClick={handleEditMember}
                                                loading={loading}
                                                type='primary'
                                                className='button-color btn-header'
                                            >
                                                Save
                                            </Button>
                                        )
                                    }
                                </Space>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default AddEditMember
